import React, { useState } from 'react';
import BloodUploadTrackerTable from '../../components/BloodUploadTracker/BloodUploadTrackerTable';
import Select, { SelectOption } from '../../components/BaseComponents/Select';
import DatePickerComp from '../../components/BaseComponents/DatePicker';
import Button from '../../components/BaseComponents/Button';
import { formatInTimeZone } from 'date-fns-tz';
import './BloodUploadTracker.scss';

const membershipTypeOptions: SelectOption[] = [
    { key: 'all', value: 'All' },
    { key: 'core', value: 'Core' },
    { key: 'plus', value: 'Plus' },
    { key: 'scan', value: 'Scan' },
    { key: 'free', value: 'Free' }
];

const BloodUploadTracker: React.FC = () => {
    const [entryCount, setEntryCount] = useState(0);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [selectedMembershipType, setSelectedMembershipType] = useState<SelectOption>({
        key: 'all',
        value: 'All'
    });

    const handleStartDateChange = (date: Date | null) => {
        setStartDate(date);
        if (date && endDate && date > endDate) {
            setEndDate(null);
        }
    };

    const handleResetDates = () => {
        setStartDate(null);
        setEndDate(null);
    };

    return (
        <div className='page-container'>
            <div className='blood-upload-tracker-header sideBarPad'>
                <h2 className='blood-upload-tracker-title'>Blood Test ({entryCount})</h2>
                <div className='blood-upload-tracker-membership-filter'>
                    <Select
                        name='membership_type'
                        placeholder='Membership Type'
                        selectedOption={selectedMembershipType}
                        options={membershipTypeOptions}
                        onChange={(option) => setSelectedMembershipType(option)}
                        isError={false}
                    />
                </div>
                <div className='blood-upload-tracker-date-filter'>
                    <DatePickerComp
                        selectedDate={startDate}
                        onDateChange={handleStartDateChange}
                        placeholder='Start upload date'
                        maxDate={endDate || new Date()}
                    />
                </div>
                <div className='blood-upload-tracker-date-filter'>
                    <DatePickerComp
                        selectedDate={endDate}
                        onDateChange={setEndDate}
                        placeholder='End upload date'
                        maxDate={new Date()}
                    />
                </div>
                <div className='blood-upload-tracker-reset-btn'>
                    <Button
                        text='Reset'
                        onClick={handleResetDates}
                        width='90px'
                        height='40px'
                        isDisabled={!startDate && !endDate}
                    />
                </div>
            </div>

            <div className="blood-upload-tracker-table-container">
                <BloodUploadTrackerTable 
                    onCountUpdate={(count) => setEntryCount(count)}
                    selectedPlanType={selectedMembershipType.key !== 'all' ? selectedMembershipType.key : undefined}
                    startDate={startDate ? formatInTimeZone(startDate, Intl.DateTimeFormat().resolvedOptions().timeZone, 'yyyy-MM-dd') : undefined}
                    endDate={endDate ? formatInTimeZone(endDate, Intl.DateTimeFormat().resolvedOptions().timeZone, 'yyyy-MM-dd') : undefined}
                />
            </div>
        </div>
    );
};

export default BloodUploadTracker;
